import React__default from 'react';
import NavModuleCss from './index.module.css.js';
import { useController } from '../../modules/Controller.js';
import { useManager } from '../../modules/Manager.js';
import { composeCssClasses } from '../../utils/composeCssClasses.js';

function Nav(_ref) {
  var color = _ref.color,
      activeColor = _ref.activeColor,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? {
    bottom: '1.5rem',
    left: '50%',
    transform: 'translateX(-50%)'
  } : _ref$position;

  var _useManager = useManager(),
      _useManager$state = _useManager.state,
      slides = _useManager$state.slides,
      totalSlides = _useManager$state.totalSlides;

  var _useController = useController(),
      activeSlide = _useController.state.activeSlide,
      changeSlide = _useController.changeSlide;

  function renderButtons() {
    if (!totalSlides) return [];

    var onClickHandler = function onClickHandler(slideNumber) {
      if (slideNumber !== activeSlide) changeSlide(slideNumber);
    };

    return Array.from(slides.values()).map(function (_ref2) {
      var number = _ref2.number;
      return (// TODO: Deal with the disabled linting later:
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        React__default.createElement("li", {
          key: number,
          className: composeCssClasses('hero-slider-nav-button', NavModuleCss.Button, {
            className: NavModuleCss.Active,
            useIf: activeSlide === number
          }),
          onClick: function onClick() {
            return onClickHandler(number);
          }
        })
      );
    });
  }
  /**
   * CSS variables for the transitions.
   */


  var CSSVariables = {
    '--nav-color': color,
    '--nav-active-color': activeColor
  };
  return React__default.createElement("ul", {
    className: composeCssClasses('hero-slider-nav-wrapper', NavModuleCss.Wrapper),
    style: Object.assign(Object.assign({}, position), CSSVariables)
  }, renderButtons());
}

Nav.displayName = 'hero-slider/nav';
export { Nav };